'use client';

import {Link, LinkProps, ToSubOptions} from '@tanstack/react-router';
import {ReactNode} from 'react';

import {cn} from '../../libs';

interface SidebarLinkProps extends LinkProps {
  children: ReactNode;
  to?: ToSubOptions['to'];
}

export const SidebarLink = ({children, ...rest}: SidebarLinkProps) => {
  return (
    <Link
      className={cn(
        'flex items-center gap-2 rounded-md border border-[transparent] px-2 py-1.5 text-paragraph-md text-text-secondary transition-colors',
        'hover:bg-bg-primary',
        'hover:border-border-primary',
        '[&.active]:bg-bg-primary',
        '[&.active]:border-border-primary',
      )}
      {...rest}
    >
      {children}
    </Link>
  );
};
